import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { FeatureAccess } from '@allmysons/utils/feature-flags';

export interface StoreBranch {
  _id: string;
  name: string;
  dispatch_start_time?: string | undefined;
}

export type StoreFeatureAccess = FeatureAccess;

export interface StoreUserInfo {
  email: string;
  name: string;
  photo_url?: string;
  token: string;
  phone_number: string;
  external_id: number;
  designation?: string;
  info?: { branch: StoreBranch };
}

type UserStore = {
  // users default branch
  branch?: StoreBranch;
  setBranch: (branch?: StoreBranch) => void;
  // all branches for the user
  branches: StoreBranch[];
  setBranches: (branches: StoreBranch[]) => void;
  // users current branch
  currentBranch?: StoreBranch;
  setCurrentBranch: (currentBranch?: StoreBranch) => void;
  version?: string;
  setVersion: (version: string) => void;
  domain?: string;
  setDomain: (domain: string) => void;
  token?: string;
  setToken: (token: string) => void;
  userInfo?: StoreUserInfo;
  setUserInfo: (userInfo: StoreUserInfo) => void;
  featureAccess: StoreFeatureAccess;
  setFeatureAccess: (featureAccess: StoreFeatureAccess) => void;
  accessibility: boolean;
  setAccessibility: (accessibility: boolean) => void;
};

export const useUserZStore = create<UserStore>()(
  persist(
    (set) => ({
      branch: undefined,
      setBranch: (branch?: StoreBranch) => set({ branch }),
      branches: [],
      setBranches: (branches: StoreBranch[]) => set({ branches }),
      currentBranch: undefined,
      setCurrentBranch: (currentBranch?: StoreBranch) => set({ currentBranch }),
      version: '',
      setVersion: (version: string) => set({ version }),
      domain: '',
      setDomain: (domain: string) => set({ domain }),
      token: '',
      setToken: (token: string) => set({ token }),
      userInfo: undefined,
      setUserInfo: (userInfo: StoreUserInfo) => set({ userInfo }),
      featureAccess: {
        isAdmin: false,
        featureAccessList: [],
      },
      setFeatureAccess: (featureAccess: StoreFeatureAccess) => set({ featureAccess }),
      accessibility: false,
      setAccessibility: (accessibility: boolean) => set({ accessibility }),
    }),
    {
      name: 'voyager-user-store', // name of the item in the storage (must be unique)
    },
  ),
);
